import React from "react";
import { Card, Progress, Typography, Row, Col, Space, Flex } from "antd";

const { Title, Text } = Typography;

interface BalanceLeavesProps {
    title: string;
    totalAvailable: number;
    available: number;
    consumed: number;
    annualQuota: number;
}

const BalanceLeaves: React.FC<BalanceLeavesProps> = ({
    title,
    totalAvailable,
    available,
    consumed,
    annualQuota,
}) => {
    return (
        <Card  >
            <Title level={5}>{title}</Title>
            <Flex justify="space-between">
                <Row gutter={8}>
                    <Col span={24}>
                        <Text type="secondary">Last 7 days</Text>
                    </Col>
                    <Col span={24}>
                        <Title level={4}>{totalAvailable}</Title>
                        <Text>Total Available</Text>
                    </Col>
                    <Space direction="vertical">
                        <Text>
                            <span style={{ color: "green" }}>●</span> Available
                        </Text>
                        <Text>
                            <span style={{ color: "#1890ff" }}>●</span> Consumed
                        </Text>
                        <Text>
                            <span style={{ color: "#9e76ff" }}>●</span> Annual Quota
                        </Text>
                    </Space>
                </Row>
                <Progress
                    type="circle"
                    percent={(available / annualQuota) * 100}
                    width={80}
                    format={() => `${available}`}
                    strokeColor="#7356f1"
                />
            </Flex>
        </Card>
    );
};

export default BalanceLeaves;
